import React, { Component } from "react"
import { Formik, FormikProps, FieldProps, Field } from "formik";
import { observer, inject } from "mobx-react";
import { Grid } from "@material-ui/core"
import { IHandoversStore } from "../Stores/HandoversStore";
import { ISharedValuesStore } from "../Stores/SharedValuesStore";
import { SimpleModal } from "../Components/SimpleModal/SimpleModal";
import { STFormWrapper } from "../Components/STFormWrapper";
import { STButtonMargin } from "../Components/STButtonMargin";
import { MessageWithReplacements } from "../Components/MessageWithReplacements";
import { HandoverExtended } from "./Handover";
import { SharedValues } from "../Tools/SharedValues";
import { HandoversConfiguration } from "../WebSockets/WsConfiguration";
import { STModalWrapper, SSTFormTitleTypography, ButtonsGrid, STNote, STTextField } from "./styles";
import WsAccessor from "../WebSockets/WsAccessor";
import moment from 'moment'
import _ from "lodash";

interface IProps {
  configuration: HandoversConfiguration;
  handovers?: IHandoversStore;
  sharedValues?: ISharedValuesStore;
}

@inject("sharedValues", "handovers")
@observer
export default class AwaitingHandoverModal extends Component<IProps>{
  accessor = new WsAccessor();

  async onSubmit(values: HandoverExtended) {
    this.accessor.sendHandoverAccepted(values.id, values.receiverNote);
  }

  async onReject(values: HandoverExtended) {
    this.accessor.sendHandoverRejected(values.id, values.receiverNote);
  }

  handleClose = () => {
    // do nothing since will be closed by handovers store change monitoring
  };

  render() {
    if (!this.props.configuration || !this.props.configuration.handoversHandling) {
      return null;
    }

    let handover = this.props.handovers.awaitingHandover;
    return (
      <React.Fragment>
        <SimpleModal
          width={650}
          isOpened={!_.isEmpty(handover)}
          onClose={this.handleClose}>
          <STModalWrapper container>
            <Grid container justify="center">
              <Formik
                initialValues={handover}
                onSubmit={x => this.onSubmit(x)}
                render={(formikProps: FormikProps<HandoverExtended>) => (
                  <STFormWrapper onSubmit={formikProps.handleSubmit}>
                    <SSTFormTitleTypography>
                      {SharedValues.getLocalizationValue("handoverAcceptance")}
                    </SSTFormTitleTypography>
                    <Grid
                      container
                      spacing={16}
                      justify="flex-start"
                      alignItems="center">
                      <Grid item>
                        <MessageWithReplacements
                          message={"awaitingHandoverMessage"}
                          replacements={[
                            { key: "position", replacement: handover.positionName, bold: true },
                            { key: "who", replacement: handover.handoverFromFullName, bold: true },
                            { key: "at", replacement: moment.utc(handover.createdTimeString).local().format("d MMMM YYYY HH:mm:ss") }
                          ]} />
                      </Grid>
                    </Grid>
                    {_.isEmpty(handover.creatorNote) ? <></> : <Grid
                      container
                      spacing={16}
                      justify="flex-start"
                      alignItems="center">
                      <Grid item style={{ width: "100%", marginTop: "12px" }}>
                        <b>
                          <MessageWithReplacements
                            message={"notesFrom"}
                            replacements={[
                              { key: "who", replacement: handover.handoverFromFullName },
                            ]} />
                        </b>:<br />
                        <STNote>{handover.creatorNote}</STNote>
                      </Grid>
                    </Grid>}
                    <Grid
                      container
                      spacing={16}
                      justify="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <Field
                          name="receiverNote"
                          render={({ field }: FieldProps) => (
                            <STTextField
                              {...field}
                              fullWidth
                              multiline
                              rows="5"
                              label={SharedValues.getLocalizationValue("addYourNotes")}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <ButtonsGrid container justify="center">
                      <STButtonMargin
                        onClick={formikProps.handleSubmit}
                        variant="contained"
                        color="primary">
                        {SharedValues.getLocalizationValue("acceptHandover")}
                      </STButtonMargin>
                      <STButtonMargin
                        onClick={() => this.onReject(formikProps.values)}
                        variant="contained"
                        color="secondary">
                        {SharedValues.getLocalizationValue("rejectHandover")}
                      </STButtonMargin>
                    </ButtonsGrid>
                  </STFormWrapper>
                )}
              />
            </Grid>
          </STModalWrapper>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
